import {createSelector} from 'reselect';

import {Controller} from '@stubhub/react-store-provider';

import MAP_TYPE, {MAP_TYPE_BY_INDEX} from '../../../event-royal/containers/react-listings-filter/map_type';

const NAMESPACE = 'event';

const mapTypeSelector = createSelector(
  (state) => state[NAMESPACE]?.venueConfig?.map?.mapType || MAP_TYPE.SECTION,
  (mapType) => MAP_TYPE_BY_INDEX[mapType],
);

const controller = new Controller({
  namespace: NAMESPACE,
  mapStateToProps(state) {
    return {
      mapTypeFromState: mapTypeSelector(state),
    };
  },
});

export default controller;
